// components/features/payments/PaymentsList.tsx
import { Payment } from "../../../types/Payment";
import TableList, { SelectAction } from "../../ui/TableList";
import PaymentRow from "./PaymentRow";

interface PaymentsListProps {
  payments: Payment[];
  onAction: (payment: Payment) => void;
  onSelectPayments?: (selectedPayments: Payment[]) => void;
  selectable?: boolean;
  selectActions?: SelectAction[];
}

export default function PaymentsList({
  payments,
  onAction,
  onSelectPayments,
  selectable = false,
  selectActions
}: PaymentsListProps) {
  const columns = [
    { header: "Référence", className: "w-1/6" },
    { header: "Client", className: "hidden sm:table-cell w-1/6" },
    { header: "Email", className: "hidden md:table-cell w-1/5" },
    { header: "Téléphone", className: "hidden lg:table-cell w-1/6" },
    { header: "Montant", className: "w-1/6" },
    { header: "Statut", className: "w-1/6" },
    { header: "Transaction", className: "hidden xl:table-cell w-1/6" },
    { header: "Date", className: "hidden lg:table-cell w-1/6" },
  ];

  return (
    <TableList
      items={payments}
      columns={columns}
      getId={(payment) => payment.id}
      onAction={onAction}
      onSelectItems={onSelectPayments}
      selectable={selectable}
      emptyMessage="Aucun paiement trouvé"
      actionColumn={true}
      selectActions={selectActions}
      renderRow={(payment, isSelected, onSelect) => (
        <PaymentRow
          key={payment.id}
          payment={payment}
          onAction={onAction}
          onSelect={onSelect}
          isSelected={isSelected}
          selectable={selectable}
        />
      )}
    />
  );
}